<template>
  <div>
    <div class="float-left">
    <h4 class="mb-1">Productos sin Movimiento</h4>
    <p>{{headerInfo}}</p>
    </div>
    <div class="float-right">
    <!--    <input style="width: 50px; height: 25px;" class="ml-1" v-model="conditionValue"> </input>-->
    <b-button variant="info" v-b-toggle.filter-pane-collapse class="mt-2">Buscar</b-button>
    </div>
  </div>
</template>


<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  export default {
    name: '',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: ['headerInfo'],
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {},
    data () {
      return {
        conditionValue: 0
      }
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
    },
    watch: {},
    computed: {},
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
      // ********************************************** VUEX COMMITS ***************************************************
      // ********************************************** REQUESTS *******************************************************
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/components/GeneralKeyKpiAnalysis/ProductWmHeader.vue